import { render } from "./CreateCourse.vue.js?vue&type=template&id=f57f0502!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateCourse.vue?vue&type=template&id=f57f0502"
import script from "./CreateCourse.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/courses/CreateCourse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f57f0502"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f57f0502', __exports__)) {
    api.reload('f57f0502', __exports__)
  }
  
  module.hot.accept("./CreateCourse.vue.js?vue&type=template&id=f57f0502!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateCourse.vue?vue&type=template&id=f57f0502", () => {
    api.rerender('f57f0502', render)
  })

}


export default __exports__